import { type FunctionComponent, type PropsWithChildren, type ReactNode, useState } from 'react';
import { Drawer } from '../../../../common-components/drawer/drawer.component';
import { DropdownMenu, DropdownMenuSelect } from '../../../../common-components/dropdown-menu/dropdown-menu.component';
import ChevronRightIcon from '../../../../svgs/untitled-ui/chevron-right.svg';

export type ProductOptionsWrapperProps = {
	groupName?: string;
	selectedName: string;
	children: ReactNode[];
};

export const ProductOptionsDrawer: FunctionComponent<PropsWithChildren<ProductOptionsWrapperProps>> = ({
	groupName,
	selectedName,
	children
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const titleValue = `Select ${groupName}`;
	const drawerTitle: JSX.Element = <div className="flex flex-row flex-nowrap items-center justify-start w-100 f4 pr4">{titleValue}</div>;

	const toggle = () => setIsOpen(!isOpen);

	return (
		<div className="ba br2 theme-luxury:border-none! pointer relative" data-testid="product-options-drawer">
			<DropdownMenuSelect toggle={toggle} expanded={isOpen}>
				{selectedName}
				<ChevronRightIcon className="flex-end ml2 f3 w2" />
			</DropdownMenuSelect>
			{isOpen && (
				<Drawer title={drawerTitle} ariaLabel={titleValue} direction="right" showOverlay={false}>
					{children}
				</Drawer>
			)}
		</div>
	);
};

export const ProductOptionsDropdown: FunctionComponent<PropsWithChildren<ProductOptionsWrapperProps>> = ({ selectedName, children }) => (
	<div data-testid="product-options-dropdown" data-automation="product-options-dropdown" style={{ width: '18rem' }}>
		<DropdownMenu title={selectedName} shouldCloseOnChoice={true}>
			{children}
		</DropdownMenu>
	</div>
);

export const ProductOptionsGrid: FunctionComponent<PropsWithChildren> = ({ children }) => (
	<div
		className="flex flex-row flex-wrap items-start mt2 w-100"
		data-testid="product-options-grid"
		data-automation="product-options-grid"
		style={{ gap: '.5rem' }}>
		{children}
	</div>
);
